import { Link, useMatch } from "react-router-dom";
import site from "../data/site";
import projects from "../data/projects";

/**
 * The thin bar at the top of every page, as a breadcrumb trail:
 *
 *   home page:     Charles Ingea / Portfolio
 *   project page:  Charles Ingea / Portfolio / Cadavre Exquis
 *
 * The name links home; on a project page "Portfolio" links home too.
 * The name is set in `src/data/site.js`, project titles in `projects.js`.
 */
export default function SiteHeader() {
  // On a project page, find which project from the URL (/cadavre-exquis…)
  const match = useMatch("/:slug");
  const project = match && projects.find((p) => p.slug === match.params.slug);

  return (
    <header className="site-header">
      <Link to="/" className="site-header__name">
        {site.name}
      </Link>

      <span className="site-header__sep">/</span>
      {project ? (
        <Link to="/" className="site-header__crumb">
          Portfolio
        </Link>
      ) : (
        <span className="site-header__crumb">Portfolio</span>
      )}

      {project && (
        <>
          <span className="site-header__sep">/</span>
          <span className="site-header__crumb site-header__crumb--current">
            {project.title}
          </span>
        </>
      )}
    </header>
  );
}
